export const StockSliderStyles = {
    sliderContainer:'brandProductSlider stockSlider px-[35px] py-30 max-[767px]:pb-[0] md:py-45 md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:flex max-[767px]:border-b-1 max-[767px]:border-[#666666]',
    sliderLeftContainer:'sliderLeftContainer text-center md:text-left md:w-[20%] max-[767px]:mb-[90px]',
    blockSliderWrapper:'blockSliderWrapper md:w-[80%] bg-white stockSliderWRAP',
    symbol:'symbol font-Regular text-[36px] leading-[43.2px] font-Light md:text-[48px] text-green mb-[15px] md:mb-[30px] leading-[57.6px]',
    title:'title font-Regular text-[14px] md:text-[21px] font-bold leading-[21px] md:leading-[31.5px] tracking-[0.53px]',
    blockSlide:'blockSlide !block text-center',
    subHeading:'subHeading font-Regular text-black tracking-[0.53px] text-[21px] font-[700] leading-[21px] lg:leading-[31.5px] mb-[25px] !block',
    description:'description !block text-center font-Light text-green text-[36px]  leading-[43.2px] md:text-[60px] md:leading-[72px]',
    descriptionWrapper:'descriptionWrapper',
    shareUp:'shareUp -rotate-90 ml-[12px]',
    shareDown:'shareDown rotate-90 ml-[12px]',
    prevArrow:'prevArrow',
    nextArrow:'nextArrow',
 }
